import { render, staticRenderFns } from "./goods-group.vue?vue&type=template&id=bca382c4&"
import script from "./goods-group.vue?vue&type=script&lang=js&"
export * from "./goods-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports